import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "no-tabs sent-geo-modal" }
const _hoisted_2 = { class: "col-sm-6 col-md-6 col-lg-6 col-xl-5 col-xxl-4" }
const _hoisted_3 = { class: "me-2" }
const _hoisted_4 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxMasterDetail = _resolveComponent("DxMasterDetail")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.filterButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn btn-primary btn-sm",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args))),
          style: {"margin-bottom":"-50px","z-index":"2","position":"relative"}
        }, _toDisplayString(_ctx.t('modules.forms.list.deleteFilters')), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_DxDataGrid, {
      ref: _ctx.dataGridRef,
      "allow-column-reordering": true,
      "allow-column-resizing": true,
      "column-auto-width": true,
      "column-hiding-enabled": true,
      "data-source": _ctx.store,
      "hover-state-enabled": true,
      "remote-operations": _ctx.remoteOperations,
      "show-borders": true,
      "show-column-lines": true,
      class: "dx-selection-disabled",
      onOptionChanged: _ctx.checkFilters
    }, {
      "master-detail": _withCtx(({ data }) => [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t('modules.forms.form_history_table_head')) + ": ", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data.details, (detail, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "list-group-item d-flex justify-content-between align-items-start small"
            }, [
              _createElementVNode("strong", _hoisted_3, _toDisplayString(detail.fieldName) + ":", 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(detail.value), 1)
            ]))
          }), 128))
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxHeaderFilter, { visible: true }),
        _createVNode(_component_DxPaging, {
          "page-index": 0,
          "page-size": 20
        }),
        _createVNode(_component_DxPager, {
          "show-info": true,
          "show-navigation-buttons": true,
          visible: true
        }),
        _createVNode(_component_DxFilterRow, { visible: true }),
        _createVNode(_component_DxColumnFixing, { enabled: true }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          width: 240,
          placeholder: _ctx.$t('components.sentGeo.dataGrids.search')
        }, null, 8, ["placeholder"]),
        _createVNode(_component_DxColumn, {
          "allow-filtering": true,
          "allow-header-filtering": false,
          "allow-sorting": false,
          caption: _ctx.$t('modules.forms.list.user'),
          "filter-operations": _ctx.allowedOperations,
          "data-field": "userName"
        }, null, 8, ["caption", "filter-operations"]),
        _createVNode(_component_DxColumn, {
          "allow-filtering": true,
          "allow-header-filtering": false,
          "allow-sorting": false,
          caption: _ctx.$t('modules.forms.list.form'),
          "filter-operations": _ctx.allowedOperations,
          "data-field": "formName"
        }, null, 8, ["caption", "filter-operations"]),
        _createVNode(_component_DxColumn, {
          "allow-filtering": true,
          "allow-header-filtering": false,
          caption: _ctx.$t('modules.forms.list.createdAt'),
          "filter-operations": _ctx.allowedOperations,
          "data-field": "createdAt",
          "data-type": "date",
          format: "yyyy-MM-dd HH:mm:ss"
        }, null, 8, ["caption", "filter-operations"]),
        _createVNode(_component_DxColumn, { type: "buttons" }, {
          default: _withCtx(() => [
            _createVNode(_component_DxButton, {
              icon: "edit",
              onClick: _ctx.edit
            }, null, 8, ["onClick"]),
            _createVNode(_component_DxButton, {
              onClick: _ctx.deleteItem,
              hint: "Usuń",
              icon: "remove"
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_DxMasterDetail, {
          enabled: true,
          template: "master-detail"
        })
      ]),
      _: 1
    }, 8, ["data-source", "remote-operations", "onOptionChanged"])
  ]))
}